import { Feature } from '../models/feature.model';

export enum ActionTypes {
  RememberFeature = '[RememberFeature] action'
}

export class RememberFeature {
  public static readonly type = ActionTypes.RememberFeature;
  constructor(public payload: Feature) { }
}
